import { render, staticRenderFns } from "./ElementYearResultChiefSectionTableColumn.vue?vue&type=template&id=7dda28b4&scoped=true"
import script from "./ElementYearResultChiefSectionTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementYearResultChiefSectionTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementYearResultChiefSectionTableColumn.vue?vue&type=style&index=0&id=7dda28b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dda28b4",
  null
  
)

export default component.exports